import { Collapse, Typography } from '@material-ui/core'
import ListItemButton from '@mui/material/ListItemButton'
import { useState } from 'react'

export const ItemResolution = ({ resolution }) => {
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(!open)
  }
  return (
    <>
      <ListItemButton
        onClick={handleClick}
        style={{
          margin: 5,
          borderRadius: 5,
          boxShadow: 'rgb(0 0 0 / 16%) 0px 1px 4px',
        }}
      >
        <Typography
          style={{
            fontSize: '14px',
            fontWeight: 700,
          }}
        >
          {resolution?.full_libelle}
        </Typography>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Typography
          style={{ paddingLeft: 22, fontSize: 14 }}
          dangerouslySetInnerHTML={{ __html: resolution.contenu_bo }}
        ></Typography>
      </Collapse>
    </>
  )
}
export default ItemResolution
